module.exports = __webpack_public_path__ + "img/where-do-i.c8af4c4a.jpg";